// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__3TJUZ","labelWrapper":"InputLabel_labelWrapper__2Jaf9","history-indication":"InputLabel_history-indication__3qcKU"};